import { ImageCircle } from '$components'
import { OptionsDropdown } from '$components'
import { useAuth } from '$features/auth/hooks/use-auth'
import { SettingsRoutePath } from '$features/settings/routes/protected'
import { Router } from '$utils/router'
import { ChevronDownIcon, LogOutIcon, SettingsIcon, SupportIcon } from '$icons'
import { Text } from '$components'
import { useNavigate } from 'react-router-dom'
import type { DropdownOption } from '$components'

type ActiveUserProps = {
  onOpenSupport: () => void
}

export function ActiveUser({ onOpenSupport }: ActiveUserProps) {
  const navigate = useNavigate()
  const { user, signOut } = useAuth()

  if (!user) {
    return null
  }

  const options: DropdownOption[] = [
    {
      id: 'settings',
      value: 'Settings',
      icon: SettingsIcon,
      onClick: () => navigate(Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsProfile)),
    },
    {
      id: 'support',
      value: 'Support',
      icon: SupportIcon,
      onClick: () => onOpenSupport(),
    },
    {
      id: 'sign-out',
      value: 'Sign out',
      icon: LogOutIcon,
      onClick: () => signOut(),
    },
  ]

  return (
    <div className="flex items-center gap-2">
      <ImageCircle
        image={user.image}
        size="lg"
      />

      <Text
        type="s"
        className="truncate max-w-36"
      >
        { user.first_name } { user.last_name }
      </Text>

      <OptionsDropdown
        icon={ChevronDownIcon}
        options={options}
      />
    </div>
  )
}
